export const ROOT = `https://${
  window.location.hostname.split('.')[0]
}.localtest.me:8000`;

export const BASE_CART_ENDPOINT = '/store/cart';
export const CART_API_ENDPOINT = `${BASE_CART_ENDPOINT}/api`;

export const getProductPricePreviewEndpoint = productId =>
  `${BASE_CART_ENDPOINT}/product/price_preview/${productId}`;
